import React from 'react';
import { Box, Container, Grid, GridItem, Flex, Heading, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import TestimonialColumn from '../ui/TestimonialColumn';

const MotionBox = motion(Box);

const TESTIMONIALS = [
  {
    content:
      "Fractional Property method has transformed my approach to property investment. The properties identified are very good and the returns on my investment is beyond the expected numbers",
    name: 'Ismail',
    role: 'Investing since 2022',
  },
  {
    content:
      "I was referred to this platform by my friend and the returns are very good. The support team is very good and they sort the issues very soon. Will continue to invest more on new properties.",
    name: 'Sanllel',
    role: 'Investing since 2023',
  },
  {
    content:
      "their fees are low and the returns are very good. good thing is i can invest on both house n office properties and different countries. thanks you B-}",
    name: 'Alok',
    role: 'Investing since 2021',
  },
  {
    content:
      "I have been investing with them for many year and they have been delivering consistantly. what i like with them is transparency and clear communication",
    name: 'Emre',
    role: 'Investing since 2020',
  },
  {
    content:
      "Cara yang sangat bagus untuk membeli hartanah. boleh menambah baik untuk menambah lebih banyak hartanah di Malaysia atau Indonesia.",
    name: 'Yusuf',
    role: 'Investing since 2022',
  },
  {
    content:
      "أحب فكرة الملكية الجزئية لأنني لا أستطيع شراء عقار كامل.لقد كانت لوري عوناً كبيراً لي.",
    name: 'Ali',
    role: 'Investing since 2021',
  },
  {
    content: "منصة جيدة لشراء منزل جزئي. جلب المزيد من العقارات",
    name: 'Mohammed',
    role: 'Investing since 2022',
  },
];

const TestimonialsSection = () => {
  const firstColumn = TESTIMONIALS.slice(0, 3);
  const secondColumn = TESTIMONIALS.slice(3, 5);
  const thirdColumn = TESTIMONIALS.slice(5, 7);

  return (
    <Box
      as="section"
      py={{ base: 5, md: 5 }}
      bg="#071326"
      position="relative"
      overflow="hidden"
    >
      <Container maxW="container.xl" px={{ base: 5, md: 8 }}>
        <Box
          bg="#0A1B34"
          border="1px solid"
          borderColor="rgba(255,255,255,0.10)"
          borderRadius="8px"
          px={{ base: 5, md: 7 }}
          py={{ base: 6, md: 6 }}
        >
          <Grid
            templateColumns={{ base: '1fr', lg: '3fr 9fr' }}
            gap={{ base: 7, lg: 6 }}
            alignItems="start"
          >
            <GridItem>
              <MotionBox
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                viewport={{ once: true }}
              >
                <Heading
                  as="h2"
                  fontFamily="heading"
                  fontWeight={500}
                  fontSize={{ base: '1.6rem', md: '1.9rem' }}
                  lineHeight={1.08}
                  color="#F5F7FA"
                >
                  Trusted by
                  <br />
                  Our Investors
                </Heading>
                <Link
                  as={RouterLink}
                  to="/about"
                  mt={4}
                  display="inline-block"
                  color="#D4A85F"
                  fontFamily="body"
                  fontWeight={500}
                  fontSize="sm"
                  _hover={{ color: '#E0B873', textDecoration: 'none' }}
                >
                  View All Reviews →
                </Link>
              </MotionBox>
            </GridItem>

            <GridItem>
              <Flex
                justify="center"
                gap={4}
                position="relative"
                maxH={{ base: '360px', md: '260px' }}
                overflow="hidden"
                sx={{
                  maskImage:
                    'linear-gradient(to bottom, transparent, black 10%, black 90%, transparent)',
                  WebkitMaskImage:
                    'linear-gradient(to bottom, transparent, black 10%, black 90%, transparent)',
                }}
              >
                <TestimonialColumn testimonials={firstColumn} duration={22} />
                <TestimonialColumn
                  testimonials={secondColumn}
                  duration={28}
                  display={{ base: 'none', md: 'block' }}
                />
                <TestimonialColumn
                  testimonials={thirdColumn}
                  duration={25}
                  display={{ base: 'none', lg: 'block' }}
                />
              </Flex>
            </GridItem>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;
